export default __webpack_public_path__ + "static/media/Smart_Goal_16_9.1ba71219.png";